import { SubscriptionHookOptions, useSubscription } from '@apollo/client';

import useCompanyContext from '../useCompanyContext';
import {
  PaymentCardUpdatedSubscriptionDocument,
  PaymentCardUpdatedSubscriptionSubscription,
  PaymentCardUpdatedSubscriptionSubscriptionVariables,
} from './paymentCardUpdatedSubscription.gql';

const usePaymentCardUpdatedSubscription = (
  options: SubscriptionHookOptions<
    PaymentCardUpdatedSubscriptionSubscription,
    PaymentCardUpdatedSubscriptionSubscriptionVariables
  > = {},
) => {
  const { companyUserId } = useCompanyContext();
  if (!companyUserId) {
    throw new Error(
      'companyUserId is undefined in usePaymentCardUpdatedSubscription',
    );
  }

  return useSubscription<
    PaymentCardUpdatedSubscriptionSubscription,
    PaymentCardUpdatedSubscriptionSubscriptionVariables
  >(PaymentCardUpdatedSubscriptionDocument, {
    ...options,
    variables: { companyUserId },
  });
};

export default usePaymentCardUpdatedSubscription;
